jQuery( document ).ready(function($) {
  $('.alt-teasers__wrap, .standard-teasers__wrap').slick({
    adaptiveHeight: true,
    fade: true,
    dots: true,
    arrows: false
  });

  $('.alt-teasers__wrap, .standard-teasers__wrap').on('afterChange', function() {
    setSlickPagination();
    var target = $(this);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 40
      }, 1000);
    }
  });


  function setSlickPagination() {
    if($('.alt-teasers__wrap .slick-dots li').lengrh > 8) {
      $('.alt-teasers__wrap .slick-dots li').removeClass('visible');
      // first 3 and last 3 always visible
      $('.alt-teasers__wrap .slick-dots li:nth-child(1)').addClass('visible');
      $('.alt-teasers__wrap .slick-dots li:nth-child(2)').addClass('visible');
      $('.alt-teasers__wrap .slick-dots li:nth-child(3)').addClass('visible');
      $('.alt-teasers__wrap .slick-dots li:nth-last-child(1)').addClass('visible');
      $('.alt-teasers__wrap .slick-dots li:nth-last-child(2)').addClass('visible');
      $('.alt-teasers__wrap .slick-dots li:nth-last-child(3)').addClass('visible');

      $('.alt-teasers__wrap .slick-active').addClass('visible');
      $('.alt-teasers__wrap .slick-active').next().addClass('visible');
      $('.alt-teasers__wrap .slick-active').next().next().addClass('visible');
      $('.alt-teasers__wrap .slick-active').prev().addClass('visible');
      $('.alt-teasers__wrap .slick-active').prev().prev().addClass('visible');
    }
    else {
      $('.alt-teasers__wrap .slick-dots li').addClass('visible');
    }
    if($('.standard-teasers__wrap .slick-dots li').lengrh > 10) {
      $('.standard-teasers__wrap .slick-dots li').removeClass('visible');
      // first 3 and last 3 always visible
      $('.standard-teasers__wrap .slick-dots li:nth-child(1)').addClass('visible');
      $('.standard-teasers__wrap .slick-dots li:nth-child(2)').addClass('visible');
      $('.standard-teasers__wrap .slick-dots li:nth-child(3)').addClass('visible');
      $('.standard-teasers__wrap .slick-dots li:nth-last-child(1)').addClass('visible');
      $('.standard-teasers__wrap .slick-dots li:nth-last-child(2)').addClass('visible');
      $('.standard-teasers__wrap .slick-dots li:nth-last-child(3)').addClass('visible');

      $('.standard-teasers__wrap .slick-active').addClass('visible');
      $('.standard-teasers__wrap .slick-active').next().addClass('visible');
      $('.standard-teasers__wrap .slick-active').next().next().addClass('visible');
      $('.standard-teasers__wrap .slick-active').prev().addClass('visible');
      $('.standard-teasers__wrap .slick-active').prev().prev().addClass('visible');
    }
    else {
      $('.standard-teasers__wrap .slick-dots li').addClass('visible');
    }
  }

  setSlickPagination();
});
